import React from 'react';
import CollapsibleSection from './CollapsibleSection';
import CustomFieldValueFields from '../../CustomFieldValues/components/CustomFieldValueFields';

const CUSTOM_FIELDS_ICON = '<path d="M12 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>';

function CrmCustomFieldsSection({
  team,
  customFieldDefinitions = [],
  customFieldValues = [],
  onCustomFieldChange,
  defaultExpanded = false,
}) {
  if (customFieldDefinitions.length === 0) return null;

  const hasRequired = customFieldValues.some((cfv) => cfv.custom_field?.required);

  const handleCustomFieldValueChanged = (updatedCfv) => {
    onCustomFieldChange(updatedCfv.custom_field_id, updatedCfv.value, updatedCfv);
  };

  const title = hasRequired
    ? <span>Custom Fields <span className="required">*</span></span>
    : "Custom Fields";

  return (
    <CollapsibleSection title={title} icon={CUSTOM_FIELDS_ICON} defaultExpanded={defaultExpanded}>
      <CustomFieldValueFields
        team={team}
        customFieldValues={customFieldValues}
        customFieldValueChanged={handleCustomFieldValueChanged}
        crmLayout
        restrictCheckoutFiles={false}
      />
    </CollapsibleSection>
  );
}

export default CrmCustomFieldsSection;
